import { z } from 'zod'

/** 檔案上傳的資料 Schema */
export const uploadFileDataSchema = z.object({
  /** 檔案中心檔案 Id */
  fileId: z.string()
})

/** 檔案上傳的資料 */
export interface UploadFileData extends z.infer<typeof uploadFileDataSchema> {}
